import { Component, OnInit, Input, ViewChild, AfterViewInit, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { IChartConfig, IChartData} from './canvas-chart-interfaces';
import { ChartConfigBuilder } from './canvas-chart-models';
declare var CanvasJS: any;

@Component({
  selector: 'app-canvas-chart',
  template: `<div *ngIf="data" class="canvas-js">
    <div id="{{id}}" style="height: 400px; min-width: inherit; max-width: inherit;">

    </div>
</div>`,
  styles: [`
`]
})
export class CanvasChartComponent implements OnInit, AfterViewInit, OnChanges {

  @Input()
  data: IChartData[];
  @Input()
  id: string;
  @Input()
  title: string;
  @ViewChild('chartContainer')chartContainer: ElementRef;

  constructor() {

  }
  ngOnInit(): any {
    // console.log(`creating chart of ` + this.id);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data) {
      // not sure about the reason but without timeout dom does not take full width
      setTimeout(() => {      
        this.createChart();
      }, 10);

    }    
  }
    
  ngAfterViewInit(): void {
    // console.log(`after view init of chart with ID -- ` + this.id);

    if (this.data) {
      // not sure about the reason but without timeout dom does not take full width
      setTimeout(() => {      
        this.createChart();
      }, 10);

    }    
  }

  createChart() {
    const chart = new CanvasJS.Chart(this.id , this.prepareChartConfig());
    chart.render();
  }

  private prepareChartConfig(): IChartConfig {
    const builder: ChartConfigBuilder = new ChartConfigBuilder();
    // console.log(this.data);
    return builder.getBaseConfig()
                  .addTitle(this.title)
                  .addData(this.data);
  }
}

